export const ROUTES_TO_LANDING = {
  terms: "/terms-and-conditions",
  privacy: "/privacy-policy",
};
